/* eslint-disable */

var cookie = require('../utils/cookie');
var $ = require('jquery');

module.exports = (function() {

  showHideNewsletter();
  var form = $('#newsletter');
  var message = $("#js-newsletter-message");
  var successResponse = $('.js-newsletter-success');

  $(form).submit( function(event) {

    event.preventDefault();

    var email = $("input[name='email']").val();
    var firstname = $("input[name='firstname']").val();
    var lastname = $("input[name='lastname']").val();

    $.ajax({
      type : "POST",
      url : ajaxurl,
      data : {
        action : "newsletter_sign_up",
        email : email,
        firstname : firstname,
        lastname : lastname,
      },

      error: function(e){
        //console.log('ajax error: ' + JSON.stringify(e));
      },
      success: function(response) {
        response = parseInt(response);
        $(message).hide();

        switch (response) {
          case 200:
            handleSuccess();
            break;

          case 409:
            handleResponse('Tack för din anmälan! Glädjande nog är du redan sedan tidigare registrerad och borde inom kort ha vårt nästa nyhetsbrev.', '#66b663');
            break;

          default:
            handleResponse('Ett fel uppstod: Kontrollera att e-postadressen är korrekt.', '#f7f7f9', '#333333');
            break;
        }
      }
    });

    return false;

  });

  function handleResponse(text, color, textColor = '#ffffff') {
    $(message).find('span').text(text);
    $(message).find('span').css('color', textColor);
    $(message).css('background-color', color);
    $(message).find('div').css('border-color', color);
    $(message).show();
  }

  function handleSuccess() {
    $(form).hide();
    $(successResponse).css({
      position: 'static',
      opacity: '1',
      height: 'auto',
      marginTop: '30px'
    });
    setCookie();
  }

  function setCookie() {
    cookie.set('newsletter', 'registered', 30);
  }

  function checkCookie() {
    //console.log(cookie.get('newsletter'));
    if (cookie.get('newsletter') && typeof(cookie.get('newsletter'))) {
      return true;
    }else{
      return false;
    }
  }

  function showHideNewsletter() {
    if (checkCookie()) {
      $('.nyhetsbrev').hide();
    }
  }

})();



// WEBPACK FOOTER //
// ./components/newsletter.js